import { apiToken, calculatePriceUrl, calculatePricingUrl, pricingTiersUrl } from "../config"


// pricing api start

export const pricingApi = async () => {
    try {
        const response = await fetch(pricingTiersUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        return res.data;
    } catch(e) {
        console.error("Error fetching pricing tiers:", e);
    }
}

export const calculatePricingWithMinutes = async (data) => {
    try {
        const response = await fetch(calculatePricingUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        });
           const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || `HTTP error! status: ${response.status}`);
        }
     
        return res;
    } catch (e) {
        console.error("Error calculating pricing:", e);
        throw e; // Re-throw the error for further handling
    }
}

// pricing api end

export const calculatePrice = async (minute) => {
    try {
        const response = await fetch(calculatePriceUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify({ minutes: minute })
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        return res;
    } catch(e) {
        console.error("Error calculating price:", e);
        throw e; // Re-throw the error for further handling
    }
}